import type { AppDefinition } from '../../types/apps';

export const DriveAppDefinition: AppDefinition = {
  appId: 'drive',
  name: 'Google Drive',
  version: '1.0.0',
  description: 'Browse and search your Google Drive files',
  icon: {
    type: 'iconify',
    iconifyIcon: 'simple-icons:googledrive',
  },
  events: {},
  entityTypes: [], // Standalone app, not entity-specific
  component: 'drive',
  requiresProps: false,
  requiresEntity: false,
  actions: {},
  entityIcons: {},
};

export default DriveAppDefinition;
